import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import DeleteJobDescriptionForm from './DeleteJobDescriptionForm';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

const DeleteJobDescriptionModal = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { closeDeleteJobDescriptionModal } = useBiopharmaGroupActions();

  return (
    <StandardModal
      isOpen={biopharmaGroupState?.deleteJobDescriptionModalIsOpen}
      contentLabel={'Delete Job Description'}
      onRequestClose={() => {
        closeDeleteJobDescriptionModal();
      }}
    >
      <PageTitle text={'Delete Job Description'} />
      <DeleteJobDescriptionForm />
    </StandardModal>
  );
};

export default DeleteJobDescriptionModal;
